import * as o from "react";
import { useLayoutEffect as a } from "../../../../../@radix-ui_react-use-layout-effect@1.1.1_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-use-layout-effect/dist/index.js";
var s = o[" useId ".trim().toString()] || (() => {
}), f = 0;
function i(t) {
  const [e, r] = o.useState(s());
  return a(() => {
    r((u) => u ?? String(f++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
export {
  i as useId
};
